{
	"email": {
		"description": "Managed by your organization, you can't change it here.",
		"label": "Email",
		"title": "Email"
	},
	"load_error": {
		"description": "We can't load your profile right now.",
		"title": "Profile unavailable"
	},
	"page_title": "Profile",
	"password": {
		"change": "Change",
		"hidden": "Password set",
		"last_changed": "Last changed {{when}}.",
		"never_changed": "No change recorded",
		"title": "Password"
	},
	"photo_name": {
		"description": "How you appear to the people you share with.",
		"invalid_type": "Choose a JPEG, PNG or WebP image.",
		"name_label": "Display name",
		"name_saved": "Name updated.",
		"remove_photo": "Remove",
		"removing": "Removing the photo…",
		"save": "Save",
		"saving": "Saving…",
		"title": "Photo and name",
		"too_large": "Choose an image smaller than {{size}} MB.",
		"upload_error": "The photo could not be uploaded.",
		"upload_photo": "Upload photo",
		"uploading": "Uploading the photo…"
	},
	"redirecting": "Opening the sign-in page…",
	"remove_dialog": {
		"cancel": "Cancel",
		"confirm": "Remove",
		"description": "“{{name}}” will no longer generate valid sign-in codes. Your other devices keep working.",
		"last_confirm": "Turn off",
		"last_description": "Your password alone will be enough to sign in. The authenticator app and the recovery codes will stop working.",
		"last_title": "Turn off two-step verification?",
		"title": "Remove this device?"
	},
	"result": {
		"cancelled": "Cancelled: nothing has changed.",
		"error": "The operation could not be completed. Please try again.",
		"success": {
			"configure_otp": "Device added.",
			"regenerate_recovery_codes": "New recovery codes are ready.",
			"remove_otp_device": "Device removed.",
			"update_password": "Password updated."
		}
	},
	"retry": "Try again",
	"two_factor": {
		"active": "On",
		"add_device": "Add device",
		"codes_generate": "Generate",
		"codes_none_hint": "If you lose your phone you won't be able to sign in. Generate new ones.",
		"codes_none_title": "No recovery codes",
		"codes_regenerate": "Regenerate",
		"codes_remaining_one": "{{count}} left · to sign in if you lose your phone",
		"codes_remaining_other": "{{count}} left · to sign in if you lose your phone",
		"codes_title": "Recovery codes",
		"description": "Required at every sign-in from a new device.",
		"device_configured": "Set up on {{date}}",
		"device_default_name": "Authenticator app",
		"enable": "Turn on",
		"error_description": "We can't read the status of two-step verification. Your account has not changed.",
		"error_title": "Status unavailable",
		"inactive": "Off",
		"remove_device": "Remove",
		"remove_device_label": "Remove {{name}}",
		"setup_hint": "Google Authenticator, Microsoft Authenticator or similar",
		"setup_title": "Use an authenticator app",
		"title": "Two-step verification"
	}
}
